export default __webpack_public_path__ + "static/media/jace-3.9359cd18.png";